import styles from 'css/src/components/app/chat-tab/components/AgentModal.module.scss';

import React from 'react';

import type { AgentOption } from './agents';
import { AVAILABLE_AGENTS } from './agents';

import Modal, { MODAL_SIZES } from 'js/src/components/common/ui/modal';

interface AgentModalProps {
    showing: boolean;
    onHide: VoidFunction;
    selectedAgentValue: string;
    onSelectAgent: (agentValue: string) => void;
}

const AgentModal: React.FC<AgentModalProps> = ({
    showing,
    onHide,
    selectedAgentValue,
    onSelectAgent,
}) => {
    const handleSelect = (value: string) => {
        onSelectAgent(value);
        onHide();
    };

    return (
        <Modal showing={showing} onHidden={onHide} title="Agent" size={MODAL_SIZES.SM}>
            <div className="d-flex flex-column gap-2">
                {AVAILABLE_AGENTS.map((agent: AgentOption) => {
                    const isSelected = agent.value === selectedAgentValue;
                    return (
                        <button
                            key={agent.value}
                            type="button"
                            className={`d-flex flex-column align-items-start position-relative w-100 text-start rounded-3 p-l5-12 ${
                                styles['agent-tile']
                            } ${isSelected ? styles['agent-tile--selected'] : ''}`}
                            onClick={() => handleSelect(agent.value)}
                        >
                            <span className={`fw-semibold ${styles['agent-name']}`}>
                                {agent.label}
                            </span>
                            <span className={`font-monospace color-grey-500 ${styles['agent-id']}`}>
                                id: {agent.value}
                            </span>
                            {isSelected && (
                                <i
                                    translate="no"
                                    className={`material-symbols-outlined position-absolute color-primary ${styles['agent-check']}`}
                                    aria-hidden
                                >
                                    check
                                </i>
                            )}
                        </button>
                    );
                })}
            </div>
        </Modal>
    );
};

export default AgentModal;
